import { render, staticRenderFns } from "./TaskHistory.vue?vue&type=template&id=585f4d52&"
import script from "./TaskHistory.vue?vue&type=script&lang=js&"
export * from "./TaskHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports